"use strict";
var ui_extensions = require("ui-extensions");
var ui_templates  = require("ui-templates");
var lib_core = require("lib-core");

var ErrorMessageView = function (editorHolder, model) {
    var self =  this;
    this.editorHolder = editorHolder;
    this.model = model;
    this.errorModal = null;

    this.model.errorMessage.onChange({},
        function(errorMessage) {
            if(!errorMessage){
                if(self.errorModal) self.errorModal.remove();
                // when manually removed don't trigger callback
                return;
            }
            var title;
            var message;
            var callback;
            var allow_close;
            if(!self.model.requiresPopup(errorMessage)) {
                self.model.errorMessageClosed();
                return;
            }
            title = errorMessage.title;
            message = errorMessage.message;
            if(self.requiresReload(errorMessage)) {
                callback = function() {location.reload();};
                message += '<BR/>To recover from this error, the editor will reload now.';
            }
            if (self.allowsClosing(errorMessage)) {
                allow_close = true;
            } else {
                allow_close = false;
                message += '<BR/>This is a blocking issue, please contact us to get it resolved.';
            }
            var wrapped_callback = function() {
                self.model.errorMessageClosed();
                if(callback) callback();
            };
            self.showError(title, message, allow_close, wrapped_callback);
        });
};

lib_core.inherit(ErrorMessageView, ui_extensions.AbstractUIView);

module.exports = ErrorMessageView;


ErrorMessageView.prototype.requiresReload = function (errorMessage) {
    if(!this.model.reload_on_critical_error()) return false;
    if(errorMessage.criticality === lib_core.logError.criticality.CRITICAL) return true;
    return false;
};

ErrorMessageView.prototype.allowsClosing = function (errorMessage) {
    if(errorMessage.criticality === lib_core.logError.criticality.BLOCKING) return false;
    return true;
};

ErrorMessageView.prototype.showError = function (title, message, allow_close, callback) {
    var self = this;
    this.errorModal = new ui_templates.Modal({
        target: this.editorHolder,
        fields: {
            'title': title,
            'body': message
        }
    });
    this.errorModal.setTheme("error");

    if(allow_close) {
        this.errorModal.$el.on('Cioui:Modal:close:clicked', function(){
            self.errorModal.remove();
            if(callback) callback();
        });
    }
};
